import { useGetPlatformCatalogs } from "@bvhi/backend-api/apis/api/platform-catalog/platform-catalog";
import { BVHIErrorsAlerts } from "../../../../../../components/bvhi-error-alerts";
import { useAuthContext } from "../../../../../../context/use-auth-context";
import { Route } from "../../../../../../routes/_main/app/catalogs.index";

export const CatalogsErrorAlerts = () => {
  const { currentUser } = useAuthContext();
  const searchParams = Route.useSearch();
  const { error } = useGetPlatformCatalogs(currentUser?.organisation?.id ?? "", searchParams);

  return <BVHIErrorsAlerts error={error} />;
};
